import React from 'react'

const ReservationTableDetail = () => {
  return (
    <div>
      
    </div>
  )
}

export default ReservationTableDetail
